await import('/app/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/app/src/.umi/umi.ts');
export default 1;